import type { CSSProperties, SVGProps } from 'react';

export const data = [
  // Choice - try and choose
  {
    name: 'choice',
    paths: [
      'M109.026,23.672l-7.645,32.712-8.394-8.365L70.51,70.419v45.543H57.457V70.222l-1.765-1.76,0,0-20.572-20.5-8.394,8.365L19.083,23.609l32.824,7.619-8.394,8.365L64.086,60.1,84.6,39.656,76.2,31.291Z',
    ],
  },
  {
    name: 'play1',
    paths: ['M342 214l468 298-468 298v-596z'],
  },
  {
    name: 'pause1',
    paths: ['M598 214h170v596h-170v-596zM256 810v-596h170v596h-170z'],
  },
  {
    name: 'home1',
    paths: [
      'M1024 590.444l-512-397.426-512 397.428v-162.038l512-397.426 512 397.428zM896 576v384h-256v-256h-256v256h-256v-384l384-288z',
    ],
  },
  {
    name: 'home2',
    paths: ['M1024 608l-192-192v-288h-128v160l-192-192-512 512v32h128v320h320v-192h128v192h320v-320h128z'],
  },
  {
    name: 'newspaper',
    paths: [
      'M896 256v-128h-896v704c0 35.346 28.654 64 64 64h864c53.022 0 96-42.978 96-96v-544h-128zM832 832h-768v-640h768v640zM128 320h640v64h-640zM512 448h256v64h-256zM512 576h256v64h-256zM512 704h192v64h-192zM128 448h320v320h-320z',
    ],
  },
  {
    name: 'pencil',
    paths: [
      'M864 0c88.364 0 160 71.634 160 160 0 36.020-11.91 69.258-32 96l-64 64-224-224 64-64c26.742-20.090 59.978-32 96-32zM64 736l-64 288 288-64 592-592-224-224-592 592zM715.578 363.578l-448 448-55.156-55.156 448-448 55.156 55.156z',
    ],
  },
  {
    name: 'image',
    paths: [
      'M959.884 128c0.040 0.034 0.082 0.076 0.116 0.116v767.77c-0.034 0.040-0.076 0.082-0.116 0.116h-895.77c-0.040-0.034-0.082-0.076-0.114-0.116v-767.772c0.034-0.040 0.076-0.082 0.114-0.114h895.77zM960 64h-896c-35.2 0-64 28.8-64 64v768c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64v-768c0-35.2-28.8-64-64-64v0z',
      'M832 288c0 53.020-42.98 96-96 96s-96-42.98-96-96 42.98-96 96-96 96 42.98 96 96z',
      'M896 832h-768v-128l224-384 256 320h64l224-192z',
    ],
  },
  {
    name: 'connection',
    paths: [
      'M640 576c105.87 0 201.87 43.066 271.402 112.598l-90.468 90.468c-46.354-46.356-110.356-75.066-180.934-75.066s-134.578 28.71-180.934 75.066l-90.468-90.468c69.532-69.532 165.532-112.598 271.402-112.598zM187.452 507.452c120.88-120.88 281.598-187.452 452.548-187.452s331.668 66.572 452.55 187.452l-90.51 90.508c-96.706-96.704-225.28-149.96-362.040-149.96-136.762 0-265.334 53.256-362.038 149.962l-90.51-90.51zM988.784 134.438c106.702 45.132 202.516 109.728 284.782 191.996v0l-90.508 90.508c-145.056-145.056-337.92-224.942-543.058-224.942-205.14 0-398 79.886-543.058 224.942l-90.51-90.51c82.268-82.266 178.082-146.862 284.784-191.994 110.504-46.738 227.852-70.438 348.784-70.438s238.278 23.7 348.784 70.438zM576 896c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64z',
    ],
  },
  {
    name: 'podcast',
    paths: [
      'M1024 512c0-282.77-229.23-512-512-512s-512 229.23-512 512c0 220.054 138.836 407.664 333.686 480.068l-13.686 31.932h384l-13.686-31.932c194.85-72.404 333.686-260.014 333.686-480.068zM486.79 634.826c-22.808-9.788-38.79-32.436-38.79-58.826 0-35.346 28.654-64 64-64s64 28.654 64 64c0 26.39-15.978 49.044-38.786 58.834l-25.214-58.834-25.21 58.826zM538.268 637.292c58.092-12.118 101.732-63.602 101.732-125.292 0-70.694-57.306-128-128-128-70.692 0-128 57.306-128 128 0 61.692 43.662 113.122 101.76 125.228l-74.624 174.122c-91.23-39.15-155.136-129.784-155.136-235.35 0-141.384 114.616-268 256-268s256 126.616 256 268c0 105.566-63.906 196.2-155.136 235.35l-74.596-174.058zM688.448 987.708l-73.924-172.486c126.446-42.738 217.476-162.346 217.476-303.222 0-176.73-143.268-320-320-320-176.73 0-320 143.27-320 320 0 140.876 91.030 260.484 217.476 303.222l-73.924 172.486c-159.594-68.488-271.386-227.034-271.386-411.708 0-247.332 200.502-459.834 447.834-459.834s447.834 212.502 447.834 459.834c0 184.674-111.792 343.22-271.386 411.708z',
    ],
  },
  {
    name: 'books',
    paths: [
      'M224 128h-192c-17.6 0-32 14.4-32 32v704c0 17.6 14.4 32 32 32h192c17.6 0 32-14.4 32-32v-704c0-17.6-14.4-32-32-32zM192 320h-128v-64h128v64z',
      'M544 128h-192c-17.6 0-32 14.4-32 32v704c0 17.6 14.4 32 32 32h192c17.6 0 32-14.4 32-32v-704c0-17.6-14.4-32-32-32zM512 320h-128v-64h128v64z',
      'M765.088 177.48l-171.464 86.394c-15.716 7.918-22.096 27.258-14.178 42.976l287.978 571.548c7.918 15.718 27.258 22.098 42.976 14.178l171.464-86.392c15.716-7.92 22.096-27.26 14.178-42.974l-287.978-571.55c-7.92-15.718-27.26-22.1-42.976-14.18z',
    ],
  },
  {
    name: 'file-text',
    paths: [
      'M864 0h-768c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h768c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM832 896h-704v-768h704v768zM256 448h448v64h-448zM256 576h448v64h-448zM256 704h448v64h-448zM256 320h448v64h-448z',
    ],
  },
  {
    name: 'profile',
    paths: [
      'M864 0h-768c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h768c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM832 896h-704v-768h704v768zM256 576h448v64h-448zM256 704h448v64h-448zM320 288c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96zM480 384h-128c-52.8 0-96 28.8-96 64v64h320v-64c0-35.2-43.2-64-96-64z',
    ],
  },
  {
    name: 'price-tag',
    paths: [
      'M976 0h-384c-26.4 0-63.274 15.274-81.942 33.942l-476.116 476.116c-18.668 18.668-18.668 49.214 0 67.882l412.118 412.118c18.668 18.668 49.214 18.668 67.882 0l476.118-476.118c18.666-18.666 33.94-55.54 33.94-81.94v-384c0-26.4-21.6-48-48-48zM736 384c-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96z',
    ],
  },
  {
    name: 'cart',
    paths: [
      'M384 928c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z',
      'M1024 928c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z',
      'M1024 512v-384h-768c0-35.346-28.654-64-64-64h-192v64h128l48.074 412.054c-29.294 23.458-48.074 59.5-48.074 99.946 0 70.696 57.308 128 128 128h768v-64h-768c-35.346 0-64-28.654-64-64 0-0.218 0.014-0.436 0.016-0.656l831.984-127.344z',
    ],
  },
  {
    name: 'credit-card',
    paths: [
      'M928 128h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM96 192h832c17.346 0 32 14.654 32 32v96h-896v-96c0-17.346 14.654-32 32-32zM928 832h-832c-17.346 0-32-14.654-32-32v-288h896v288c0 17.346-14.654 32-32 32zM128 640h64v128h-64zM256 640h64v128h-64zM384 640h64v128h-64z',
    ],
  },
  {
    name: 'phone',
    paths: [
      'M704 640c-64 64-64 128-128 128s-128-64-192-128-128-128-128-192 64-64 128-128-128-256-192-256-192 192-192 192c0 128 131.5 387.5 256 512s384 256 512 256c0 0 192-128 192-192s-192-256-256-192z',
    ],
  },
  {
    name: 'address-book',
    paths: [
      'M192 0v1024h768v-1024h-768zM576 256.33c70.51 0 127.67 57.16 127.67 127.67s-57.16 127.67-127.67 127.67-127.67-57.16-127.67-127.67 57.16-127.67 127.67-127.67v0zM768 768h-384v-64c0-70.696 57.306-128 128-128v0h128c70.696 0 128 57.304 128 128v64z',
      'M64 64h96v192h-96v-192z',
      'M64 320h96v192h-96v-192z',
      'M64 576h96v192h-96v-192z',
      'M64 832h96v192h-96v-192z',
    ],
  },
  {
    name: 'envelope',
    paths: [
      'M928 128h-832c-52.8 0-96 43.2-96 96v640c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-640c0-52.8-43.2-96-96-96zM398.74 550.372l-270.74 210.892v-501.642l270.74 290.75zM176.38 256h671.24l-335.62 252-335.62-252zM409.288 561.698l102.712 110.302 102.71-110.302 210.554 270.302h-626.528l210.552-270.302zM625.26 550.372l270.74-290.75v501.642l-270.74-210.892z',
    ],
  },
  {
    name: 'location',
    paths: [
      'M512 0c-176.732 0-320 143.268-320 320 0 320 320 704 320 704s320-384 320-704c0-176.732-143.27-320-320-320zM512 512c-106.040 0-192-85.96-192-192s85.96-192 192-192 192 85.96 192 192-85.96 192-192 192z',
    ],
  },
  {
    name: 'clock1',
    paths: [
      'M658.744 749.256l-210.744-210.746v-282.51h128v229.49l173.256 173.254zM512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 896c-212.078 0-384-171.922-384-384s171.922-384 384-384c212.078 0 384 171.922 384 384s-171.922 384-384 384z',
    ],
  },
  {
    name: 'clock2',
    paths: [
      'M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM658.744 749.256l-210.744-210.746v-282.51h128v229.49l173.256 173.254-90.512 90.512z',
    ],
  },
  {
    name: 'alarm',
    paths: [
      'M512 128c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM512 936c-198.824 0-360-161.178-360-360 0-198.824 161.176-360 360-360 198.822 0 360 161.176 360 360 0 198.822-161.178 360-360 360zM934.784 287.174c16.042-28.052 25.216-60.542 25.216-95.174 0-106.040-85.96-192-192-192-61.818 0-116.802 29.222-151.92 74.596 131.884 27.236 245.206 105.198 318.704 212.578v0zM407.92 74.596c-35.116-45.374-90.102-74.596-151.92-74.596-106.040 0-192 85.96-192 192 0 34.632 9.174 67.122 25.216 95.174 73.5-107.38 186.822-185.342 318.704-212.578z',
      'M512 576v-256h-64v320h256v-64z',
    ],
  },
  {
    name: 'calendar',
    paths: [
      'M320 384h128v128h-128zM512 384h128v128h-128zM704 384h128v128h-128zM128 768h128v128h-128zM320 768h128v128h-128zM512 768h128v128h-128zM320 576h128v128h-128zM512 576h128v128h-128zM704 576h128v128h-128zM128 576h128v128h-128zM832 0v64h-128v-64h-448v64h-128v-64h-128v1024h960v-1024h-128zM896 960h-832v-704h832v704z',
    ],
  },
  {
    name: 'keyboard',
    paths: [
      'M1088 128h-1024c-35.2 0-64 28.8-64 64v640c0 35.2 28.8 64 64 64h1024c35.2 0 64-28.8 64-64v-640c0-35.2-28.8-64-64-64zM640 256h128v128h-128v-128zM832 448v128h-128v-128h128zM448 256h128v128h-128v-128zM640 448v128h-128v-128h128zM256 256h128v128h-128v-128zM448 448v128h-128v-128h128zM128 256h64v128h-64v-128zM128 448h128v128h-128v-128zM192 768h-64v-128h64v128zM768 768h-512v-128h512v128zM1024 768h-192v-128h192v128zM1024 576h-128v-128h128v128zM1024 384h-192v-128h192v128z',
    ],
  },
  {
    name: 'display',
    paths: ['M0 64v640h1024v-640h-1024zM960 640h-896v-512h896v512zM672 768h-320l-32 128-64 64h512l-64-64z'],
  },
  {
    name: 'laptop',
    paths: [
      'M896 704v-512c0-35.2-28.8-64-64-64h-640c-35.2 0-64 28.8-64 64v512h-128v192h1024v-192h-128zM640 832h-256v-64h256v64zM832 704h-640v-511.886c0.034-0.040 0.076-0.082 0.114-0.114h639.77c0.040 0.034 0.082 0.076 0.116 0.116v511.884z',
    ],
  },
  {
    name: 'mobile1',
    paths: [
      'M736 0h-448c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h448c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM384 48h256v32h-256v-32zM512 960c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64zM768 768h-512v-640h512v640z',
    ],
  },
  {
    name: 'mobile2',
    paths: [
      'M768 0h-576c-35.2 0-64 28.798-64 64v896c0 35.2 28.798 64 64 64h576c35.2 0 64-28.8 64-64v-896c0-35.202-28.8-64-64-64zM480 977.782c-27.492 0-49.782-22.29-49.782-49.782s22.29-49.782 49.782-49.782 49.782 22.29 49.782 49.782-22.29 49.782-49.782 49.782zM768 832h-576v-704h576v704z',
    ],
  },
  {
    name: 'tablet',
    paths: [
      'M800 0h-640c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h640c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM480 992c-17.672 0-32-14.326-32-32s14.328-32 32-32 32 14.326 32 32-14.328 32-32 32zM768 896h-576v-768h576v768z',
    ],
  },
  {
    name: 'tv',
    paths: [
      'M981.188 288.108c-88.808-12.768-183.382-22.016-282.076-27.22l164.888-164.888-64-64-224.558 224.556c-21.006-0.368-42.156-0.556-63.442-0.556v0l-256-256-64 64 194.196 194.196c-120.922 4.242-236.338 14.524-343.386 29.912-27.532 107.726-42.81 226.752-42.81 351.892s15.278 244.166 42.804 351.89c143.642 20.652 302.34 32.11 469.196 32.11s325.55-11.458 469.188-32.11c27.534-107.724 42.812-226.75 42.812-351.89s-15.278-244.166-42.812-351.892zM863.892 874.594c-107.73 13.766-226.75 21.406-351.892 21.406s-244.166-7.64-351.892-21.406c-20.648-71.816-32.108-151.166-32.108-234.594 0-83.43 11.458-162.78 32.108-234.596 107.726-13.766 226.75-21.404 351.892-21.404 125.136 0 244.162 7.638 351.886 21.404 20.656 71.816 32.114 151.166 32.114 234.596 0 83.428-11.458 162.778-32.108 234.594z',
    ],
  },
  {
    name: 'download',
    paths: [
      'M512 576l256-256h-192v-256h-128v256h-192zM744.726 471.272l-71.74 71.742 260.080 96.986-421.066 157.018-421.066-157.018 260.080-96.986-71.742-71.742-279.272 104.728v256l512 192 512-192v-256z',
    ],
  },
  {
    name: 'floppy-disk',
    paths: [
      'M896 0h-896v1024h1024v-896l-128-128zM512 128h128v256h-128v-256zM896 896h-768v-768h64v320h576v-320h74.978l53.022 53.018v714.982z',
    ],
  },
  {
    name: 'database',
    paths: [
      'M512 0c-282.77 0-512 71.634-512 160v128c0 88.366 229.23 160 512 160s512-71.634 512-160v-128c0-88.366-229.23-160-512-160z',
      'M512 544c-282.77 0-512-71.634-512-160v192c0 88.366 229.23 160 512 160s512-71.634 512-160v-192c0 88.366-229.23 160-512 160z',
      'M512 832c-282.77 0-512-71.634-512-160v192c0 88.366 229.23 160 512 160s512-71.634 512-160v-192c0 88.366-229.23 160-512 160z',
    ],
  },
  {
    name: 'bubble',
    paths: [
      'M512 64c282.77 0 512 186.25 512 416 0 229.752-229.23 416-512 416-27.156 0-53.81-1.734-79.824-5.044-109.978 109.978-241.25 129.7-368.176 132.596v-26.916c68.536-33.578 128-94.74 128-164.636 0-9.754-0.758-19.33-2.164-28.696-115.796-76.264-189.836-192.754-189.836-323.304 0-229.75 229.23-416 512-416z',
    ],
  },
  {
    name: 'bubbles',
    paths: [
      'M1088 901.166c0 45.5 26.028 84.908 64 104.184v15.938c-10.626 1.454-21.472 2.224-32.5 2.224-68.008 0-129.348-28.528-172.722-74.264-26.222 6.982-54.002 10.752-82.778 10.752-159.058 0-288-114.616-288-256s128.942-256 288-256c159.058 0 288 114.616 288 256 0 55.348-19.764 106.592-53.356 148.466-6.824 14.824-10.644 31.312-10.644 48.7zM512 0c278.458 0 504.992 180.614 511.836 405.52-49.182-21.92-103.586-33.52-159.836-33.52-95.56 0-185.816 33.446-254.138 94.178-70.846 62.972-109.862 147.434-109.862 237.822 0 44.672 9.544 87.888 27.736 127.788-5.228 0.126-10.468 0.212-15.736 0.212-27.156 0-53.81-1.734-79.824-5.044-109.978 109.978-241.25 129.7-368.176 132.596v-26.916c68.536-33.578 128-94.74 128-164.636 0-9.754-0.758-19.33-2.164-28.696-115.796-76.264-189.836-192.754-189.836-323.304 0-229.75 229.23-416 512-416z',
    ],
  },
  {
    name: 'user',
    paths: [
      'M576 706.612v-52.78c70.498-39.728 128-138.772 128-237.832 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h896c0-128.968-166.898-235.64-384-253.388z',
    ],
  },
  {
    name: 'hour-glass',
    paths: [
      'M728.992 512c137.754-87.334 231.008-255.208 231.008-448 0-21.676-1.192-43.034-3.478-64h-889.042c-2.29 20.968-3.48 42.326-3.48 64 0 192.792 93.254 360.666 231.006 448-137.752 87.334-231.006 255.208-231.006 448 0 21.676 1.19 43.034 3.478 64h889.042c2.288-20.966 3.478-42.324 3.478-64 0.002-192.792-93.252-360.666-231.006-448zM160 960c0-186.912 80.162-345.414 224-397.708v-100.586c-143.838-52.29-224-210.792-224-397.706v0h704c0 186.914-80.162 345.416-224 397.706v100.586c143.838 52.294 224 210.796 224 397.708h-704zM619.626 669.594c-71.654-40.644-75.608-93.368-75.626-125.366v-64.228c0-31.994 3.804-84.914 75.744-125.664 38.504-22.364 71.808-56.348 97.048-98.336h-409.582c25.266 42.032 58.612 76.042 97.166 98.406 71.654 40.644 75.606 93.366 75.626 125.366v64.228c0 31.992-3.804 84.914-75.744 125.664-72.622 42.18-126.738 125.684-143.090 226.336h501.67c-16.364-100.708-70.53-184.248-143.212-226.406z',
    ],
  },
  {
    name: 'key',
    paths: [
      'M704 0c-176.73 0-320 143.268-320 320 0 20.026 1.858 39.616 5.376 58.624l-389.376 389.376v192c0 35.346 28.654 64 64 64h64v-64h128v-128h128v-128h128l83.042-83.042c34.010 12.316 70.696 19.042 108.958 19.042 176.73 0 320-143.268 320-320s-143.27-320-320-320zM799.874 320.126c-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96z',
    ],
  },
  {
    name: 'lock',
    paths: [
      'M592 448h-16v-192c0-105.87-86.13-192-192-192h-128c-105.87 0-192 86.13-192 192v192h-16c-26.4 0-48 21.6-48 48v480c0 26.4 21.6 48 48 48h544c26.4 0 48-21.6 48-48v-480c0-26.4-21.6-48-48-48zM192 256c0-35.29 28.71-64 64-64h128c35.29 0 64 28.71 64 64v192h-256v-192z',
    ],
  },
  {
    name: 'unlocked',
    paths: [
      'M768 64c105.87 0 192 86.13 192 192v192h-128v-192c0-35.29-28.71-64-64-64h-128c-35.29 0-64 28.71-64 64v192h16c26.4 0 48 21.6 48 48v480c0 26.4-21.6 48-48 48h-544c-26.4 0-48-21.6-48-48v-480c0-26.4 21.6-48 48-48h400v-192c0-105.87 86.13-192 192-192h128z',
    ],
  },
  {
    name: 'wrench',
    paths: [
      'M1002.934 817.876l-460.552-394.76c21.448-40.298 33.618-86.282 33.618-135.116 0-159.058-128.942-288-288-288-29.094 0-57.172 4.332-83.646 12.354l166.39 166.39c24.89 24.89 24.89 65.62 0 90.51l-101.49 101.49c-24.89 24.89-65.62 24.89-90.51 0l-166.39-166.39c-8.022 26.474-12.354 54.552-12.354 83.646 0 159.058 128.942 288 288 288 48.834 0 94.818-12.17 135.116-33.62l394.76 460.552c22.908 26.724 62.016 28.226 86.904 3.338l101.492-101.492c24.888-24.888 23.386-63.994-3.338-86.902z',
    ],
  },
  {
    name: 'equalizer1',
    paths: [
      'M448 128v-16c0-26.4-21.6-48-48-48h-160c-26.4 0-48 21.6-48 48v16h-192v128h192v16c0 26.4 21.6 48 48 48h160c26.4 0 48-21.6 48-48v-16h576v-128h-576zM256 256v-128h128v128h-128zM832 432c0-26.4-21.6-48-48-48h-160c-26.4 0-48 21.6-48 48v16h-576v128h576v16c0 26.4 21.6 48 48 48h160c26.4 0 48-21.6 48-48v-16h192v-128h-192v-16zM640 576v-128h128v128h-128zM448 752c0-26.4-21.6-48-48-48h-160c-26.4 0-48 21.6-48 48v16h-192v128h192v16c0 26.4 21.6 48 48 48h160c26.4 0 48-21.6 48-48v-16h576v-128h-576v-16zM256 896v-128h128v128h-128z',
    ],
  },
  {
    name: 'equalizer2',
    paths: [
      'M896 448h16c26.4 0 48-21.6 48-48v-160c0-26.4-21.6-48-48-48h-16v-192h-128v192h-16c-26.4 0-48 21.6-48 48v160c0 26.4 21.6 48 48 48h16v576h128v-576zM768 256h128v128h-128v-128zM592 832c26.4 0 48-21.6 48-48v-160c0-26.4-21.6-48-48-48h-16v-576h-128v576h-16c-26.4 0-48 21.6-48 48v160c0 26.4 21.6 48 48 48h16v192h128v-192h16zM448 640h128v128h-128v-128zM272 448c26.4 0 48-21.6 48-48v-160c0-26.4-21.6-48-48-48h-16v-192h-128v192h-16c-26.4 0-48 21.6-48 48v160c0 26.4 21.6 48 48 48h16v576h128v-576h16zM128 256h128v128h-128v-128z',
    ],
  },
  {
    name: 'cog',
    paths: [
      'M933.79 610.25c-53.726-93.054-21.416-212.304 72.152-266.488l-100.626-174.292c-28.75 16.854-62.176 26.518-97.846 26.518-107.536 0-194.708-87.746-194.708-195.99h-201.258c0.266 33.41-8.074 67.282-25.958 98.252-53.724 93.056-173.156 124.702-266.862 70.758l-100.624 174.292c28.97 16.472 54.050 40.588 71.886 71.478 53.638 92.908 21.512 211.92-71.708 266.224l100.626 174.292c28.65-16.696 61.916-26.254 97.4-26.254 107.196 0 194.144 87.192 194.7 194.958h201.254c-0.086-33.074 8.272-66.57 25.966-97.218 53.636-92.906 172.776-124.594 266.414-71.012l100.626-174.29c-28.78-16.466-53.692-40.498-71.434-71.228zM512 719.332c-114.508 0-207.336-92.824-207.336-207.334 0-114.508 92.826-207.334 207.336-207.334 114.508 0 207.332 92.826 207.332 207.334-0.002 114.51-92.824 207.334-207.332 207.334z',
    ],
  },
  {
    name: 'cogs',
    paths: [
      'M363.722 722.052l41.298-57.816-45.254-45.256-57.818 41.296c-10.722-5.994-22.204-10.774-34.266-14.192l-11.682-70.084h-64l-11.68 70.086c-12.062 3.418-23.544 8.198-34.266 14.192l-57.818-41.298-45.256 45.256 41.298 57.816c-5.994 10.72-10.774 22.206-14.192 34.266l-70.086 11.682v64l70.086 11.682c3.418 12.060 8.198 23.544 14.192 34.266l-41.298 57.816 45.254 45.256 57.818-41.296c10.722 5.994 22.204 10.774 34.266 14.192l11.682 70.084h64l11.68-70.086c12.062-3.418 23.544-8.198 34.266-14.192l57.818 41.296 45.254-45.256-41.298-57.816c5.994-10.72 10.774-22.206 14.192-34.266l70.088-11.68v-64l-70.086-11.682c-3.418-12.060-8.198-23.544-14.192-34.266zM224 864c-35.348 0-64-28.654-64-64s28.652-64 64-64 64 28.654 64 64-28.652 64-64 64zM1024 384v-64l-67.382-12.25c-1.242-8.046-2.832-15.978-4.724-23.79l57.558-37.1-24.492-59.128-66.944 14.468c-4.214-6.91-8.726-13.62-13.492-20.13l39.006-56.342-45.256-45.254-56.342 39.006c-6.512-4.766-13.22-9.276-20.13-13.494l14.468-66.944-59.128-24.494-37.1 57.558c-7.812-1.892-15.744-3.482-23.79-4.724l-12.252-67.382h-64l-12.252 67.382c-8.046 1.242-15.976 2.832-23.79 4.724l-37.098-57.558-59.128 24.492 14.468 66.944c-6.91 4.216-13.62 8.728-20.13 13.494l-56.342-39.006-45.254 45.254 39.006 56.342c-4.766 6.51-9.278 13.22-13.494 20.13l-66.944-14.468-24.492 59.128 57.558 37.1c-1.892 7.812-3.482 15.742-4.724 23.79l-67.384 12.252v64l67.382 12.25c1.242 8.046 2.832 15.978 4.724 23.79l-57.558 37.1 24.492 59.128 66.944-14.468c4.216 6.91 8.728 13.618 13.494 20.13l-39.006 56.342 45.254 45.256 56.342-39.006c6.51 4.766 13.22 9.276 20.13 13.492l-14.468 66.944 59.128 24.492 37.102-57.558c7.81 1.892 15.742 3.482 23.788 4.724l12.252 67.384h64l12.252-67.382c8.044-1.242 15.976-2.832 23.79-4.724l37.1 57.558 59.128-24.492-14.468-66.944c6.91-4.216 13.62-8.726 20.13-13.492l56.342 39.006 45.256-45.256-39.006-56.342c4.766-6.512 9.276-13.22 13.492-20.13l66.944 14.468 24.492-59.13-57.558-37.1c1.892-7.812 3.482-15.742 4.724-23.79l67.382-12.25zM672 491.2c-76.878 0-139.2-62.322-139.2-139.2s62.32-139.2 139.2-139.2 139.2 62.322 139.2 139.2c0 76.878-62.32 139.2-139.2 139.2z',
    ],
  },
  {
    name: 'bin',
    paths: [
      'M128 320v640c0 35.2 28.8 64 64 64h576c35.2 0 64-28.8 64-64v-640h-704zM320 896h-64v-448h64v448zM448 896h-64v-448h64v448zM576 896h-64v-448h64v448zM704 896h-64v-448h64v448z',
      'M848 128h-208v-80c0-26.4-21.6-48-48-48h-224c-26.4 0-48 21.6-48 48v80h-208c-26.4 0-48 21.6-48 48v80h832v-80c0-26.4-21.6-48-48-48zM576 128h-192v-63.198h192v63.198z',
    ],
  },
  {
    name: 'briefcase',
    paths: [
      'M960 256h-256v-64c0-35.2-28.8-64-64-64h-256c-35.204 0-64 28.8-64 64v64h-256c-35.2 0-64 28.8-64 64v576c0 35.202 28.796 64 64 64h896c35.2 0 64-28.798 64-64v-576c0-35.2-28.8-64-64-64zM384 192.116c0.034-0.040 0.074-0.082 0.114-0.116h255.772c0.042 0.034 0.082 0.076 0.118 0.116v63.884h-256.004v-63.884zM960 512h-128v96c0 17.602-14.4 32-32 32h-64c-17.604 0-32-14.398-32-32v-96h-384v96c0 17.602-14.4 32-32 32h-64c-17.602 0-32-14.398-32-32v-96h-128v-64h896v64z',
    ],
  },
  {
    name: 'truck',
    paths: [
      'M1024 576l-128-256h-192v-128c0-35.2-28.8-64-64-64h-576c-35.2 0-64 28.8-64 64v512l64 64h81.166c-10.898 18.832-17.166 40.678-17.166 64 0 70.692 57.308 128 128 128s128-57.308 128-128c0-23.322-6.268-45.168-17.166-64h354.334c-10.898 18.832-17.168 40.678-17.168 64 0 70.692 57.308 128 128 128s128-57.308 128-128c0-23.322-6.27-45.168-17.168-64h81.168v-192zM704 576v-192h132.668l96 192h-228.668z',
    ],
  },
  {
    name: 'road',
    paths: [
      'M704 1024h320l-256-1024h-192l32 256h-192l32-256h-192l-256 1024h320l32-256h320l32 256zM368 640l32-256h224l32 256h-288z',
    ],
  },
  {
    name: 'switch',
    paths: [
      'M640 146.588v135.958c36.206 15.804 69.5 38.408 98.274 67.18 60.442 60.44 93.726 140.8 93.726 226.274s-33.286 165.834-93.726 226.274c-60.44 60.44-140.798 93.726-226.274 93.726s-165.834-33.286-226.274-93.726c-60.44-60.44-93.726-140.8-93.726-226.274s33.286-165.834 93.726-226.274c28.774-28.774 62.068-51.378 98.274-67.182v-135.956c-185.048 55.080-320 226.472-320 429.412 0 247.424 200.578 448 448 448 247.424 0 448-200.576 448-448 0-202.94-134.95-374.332-320-429.412zM448 0h128v512h-128z',
    ],
  },
  {
    name: 'power-cord',
    paths: [
      'M1024 282.5l-90.506-90.5-178.746 178.752-101.5-101.502 178.75-178.75-90.5-90.5-178.75 178.75-114.748-114.75-86.626 86.624 512.002 512 86.624-86.622-114.752-114.752 178.752-178.75z',
      'M794.040 673.79l-443.824-443.824c-95.818 114.904-204.52 292.454-129.396 445.216l-132.248 132.248c-31.112 31.114-31.112 82.024 0 113.136l14.858 14.858c31.114 31.114 82.026 31.114 113.138 0l132.246-132.244c152.764 75.132 330.318-33.566 445.226-129.39z',
    ],
  },
  {
    name: 'clipboard',
    paths: [
      'M928 128h-288c0-70.692-57.306-128-128-128-70.692 0-128 57.308-128 128h-288c-17.672 0-32 14.328-32 32v832c0 17.674 14.328 32 32 32h832c17.674 0 32-14.326 32-32v-832c0-17.672-14.326-32-32-32zM512 64c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64s28.654-64 64-64zM896 960h-768v-768h128v96c0 17.672 14.328 32 32 32h448c17.674 0 32-14.328 32-32v-96h128v768z',
      'M448 858.51l-205.254-237.254 58.508-58.51 146.746 114.744 274.742-242.744 58.514 58.508z',
    ],
  },
  {
    name: 'list-numbered',
    paths: [
      'M384 832h640v128h-640zM384 448h640v128h-640zM384 64h640v128h-640zM192 0v256h-64v-192h-64v-64zM128 526v50h128v64h-192v-146l128-60v-50h-128v-64h192v146zM256 704v320h-192v-64h128v-64h-128v-64h128v-64h-128v-64z',
    ],
  },
  {
    name: 'list1',
    paths: [
      'M0 0h256v256h-256zM384 64h640v128h-640zM0 384h256v256h-256zM384 448h640v128h-640zM0 768h256v256h-256zM384 832h640v128h-640z',
    ],
  },
  {
    name: 'list2',
    paths: [
      'M384 64h640v128h-640v-128zM384 448h640v128h-640v-128zM384 832h640v128h-640v-128zM0 128c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM0 512c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM0 896c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128z',
    ],
  },
  {
    name: 'menu',
    paths: ['M64 192h896v192h-896zM64 448h896v192h-896zM64 704h896v192h-896z'],
  },
  {
    name: 'earth',
    paths: [
      'M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 960.002c-62.958 0-122.872-13.012-177.23-36.452l233.148-262.29c5.206-5.858 8.082-13.422 8.082-21.26v-96c0-17.674-14.326-32-32-32-112.99 0-232.204-117.462-233.374-118.626-6-6.002-14.14-9.374-22.626-9.374h-128c-17.672 0-32 14.328-32 32v192c0 12.122 6.848 23.202 17.69 28.622l110.31 55.156v187.886c-116.052-80.956-192-215.432-192-367.664 0-68.714 15.49-133.806 43.138-192h116.862c8.488 0 16.626-3.372 22.628-9.372l128-128c6-6.002 9.372-14.14 9.372-22.628v-77.412c40.562-12.074 83.518-18.588 128-18.588 70.406 0 137.004 16.26 196.282 45.2-4.144 3.502-8.176 7.164-12.046 11.036-36.266 36.264-56.236 84.478-56.236 135.764s19.97 99.5 56.236 135.764c36.434 36.432 85.218 56.264 135.634 56.26 3.166 0 6.342-0.080 9.518-0.236 13.814 51.802 38.752 186.656-8.404 372.334-0.444 1.744-0.696 3.488-0.842 5.224-81.324 83.080-194.7 134.656-320.142 134.656z',
    ],
  },
  {
    name: 'link',
    paths: [
      'M440.236 635.766c-13.31 0-26.616-5.076-36.77-15.23-95.134-95.136-95.134-249.934 0-345.070l192-192c46.088-46.086 107.36-71.466 172.534-71.466s126.448 25.38 172.536 71.464c95.132 95.136 95.132 249.934 0 345.070l-87.766 87.766c-20.308 20.308-53.23 20.308-73.54 0-20.306-20.306-20.306-53.232 0-73.54l87.766-87.766c54.584-54.586 54.584-143.404 0-197.99-26.442-26.442-61.6-41.004-98.996-41.004s-72.552 14.562-98.996 41.006l-192 191.998c-54.586 54.586-54.586 143.406 0 197.992 20.308 20.306 20.306 53.232 0 73.54-10.15 10.152-23.462 15.23-36.768 15.23z',
      'M256 1012c-65.176 0-126.45-25.38-172.534-71.464-95.134-95.136-95.134-249.934 0-345.070l87.764-87.764c20.308-20.306 53.234-20.306 73.54 0 20.308 20.306 20.308 53.232 0 73.54l-87.764 87.764c-54.586 54.586-54.586 143.406 0 197.992 26.44 26.44 61.598 41.002 98.994 41.002s72.552-14.562 98.998-41.006l192-191.998c54.584-54.586 54.584-143.406 0-197.992-20.308-20.308-20.306-53.232 0-73.54 20.306-20.306 53.232-20.306 73.54 0.002 95.132 95.134 95.132 249.932 0.002 345.068l-192.002 192c-46.090 46.088-107.364 71.466-172.538 71.466z',
    ],
  },
  {
    name: 'attachment',
    paths: [
      'M665.832 327.048l-64.952-64.922-324.81 324.742c-53.814 53.792-53.814 141.048 0 194.844 53.804 53.792 141.060 53.792 194.874 0l389.772-389.708c89.714-89.662 89.714-235.062 0-324.726-89.666-89.704-235.112-89.704-324.782 0l-409.23 409.178c-0.29 0.304-0.612 0.576-0.876 0.846-125.102 125.096-125.102 327.856 0 452.906 125.054 125.056 327.868 125.056 452.988 0 0.274-0.274 0.516-0.568 0.82-0.876l0.032 0.034 279.332-279.292-64.986-64.92-279.33 279.262c-0.296 0.268-0.564 0.57-0.846 0.844-89.074 89.058-233.98 89.058-323.076 0-89.062-89.042-89.062-233.922 0-322.978 0.304-0.304 0.604-0.582 0.888-0.846l-0.046-0.060 409.28-409.166c53.712-53.738 141.144-53.738 194.886 0 53.712 53.734 53.712 141.148 0 194.84l-389.772 389.7c-17.936 17.922-47.054 17.922-64.972 0-17.894-17.886-17.894-47.032 0-64.92l324.806-324.782z',
    ],
  },
  {
    name: 'bookmark',
    paths: ['M192 0v1024l320-320 320 320v-1024z'],
  },
  {
    name: 'star_empty_inside',
    paths: [
      'M16.1257 19.695C15.7807 19.695 15.4357 19.5825 15.1357 19.365L12.0457 17.1225L8.95572 19.365C8.35572 19.8 7.57571 19.8 6.97571 19.365C6.37571 18.93 6.13572 18.1875 6.36072 17.475L7.53821 13.845L4.44821 11.6025C3.84821 11.1675 3.6082 10.425 3.8332 9.71249C4.0657 9.00749 4.69571 8.54249 5.43821 8.54249H9.25571L10.4332 4.91249C10.6657 4.20749 11.2957 3.75 12.0382 3.75C12.7807 3.75 13.4107 4.20749 13.6432 4.91249L14.8207 8.54249H18.6382C19.3807 8.54249 20.0107 9 20.2432 9.705C20.4757 10.41 20.2357 11.1525 19.6282 11.595L16.5382 13.8375L17.7157 17.4675C17.9482 18.1725 17.7082 18.915 17.1007 19.3575C16.8007 19.575 16.4557 19.6875 16.1107 19.6875L16.1257 19.695ZM12.0457 15.8625C12.1582 15.8625 12.2782 15.9 12.3757 15.9675L15.7957 18.45C16.1032 18.675 16.3807 18.5025 16.4557 18.45C16.5307 18.39 16.7782 18.18 16.6582 17.82L15.3532 13.8C15.2782 13.5675 15.3532 13.3125 15.5557 13.17L18.9757 10.6875C19.2832 10.4625 19.2082 10.1475 19.1782 10.0575C19.1482 9.9675 19.0207 9.66749 18.6457 9.66749H14.4157C14.1682 9.66749 13.9582 9.51 13.8832 9.2775L12.5782 5.25748C12.4582 4.89748 12.1357 4.86749 12.0457 4.86749C11.9557 4.86749 11.6257 4.89748 11.5132 5.25748L10.2082 9.2775C10.1332 9.51 9.91571 9.66749 9.67571 9.66749H5.44572C5.06322 9.66749 4.94321 9.9675 4.91321 10.0575C4.88321 10.1475 4.80822 10.4625 5.11572 10.6875L8.53572 13.17C8.73072 13.3125 8.81321 13.5675 8.73821 13.8L7.43322 17.82C7.31322 18.18 7.56071 18.39 7.63571 18.45C7.71071 18.5025 7.98821 18.675 8.29571 18.45L11.7157 15.9675C11.8132 15.8925 11.9332 15.8625 12.0457 15.8625Z',
    ],
  },
  {
    name: 'star',
    paths: [
      'M1024 397.050l-353.78-51.408-158.22-320.582-158.216 320.582-353.784 51.408 256 249.538-60.432 352.352 316.432-166.358 316.432 166.358-60.434-352.352 256.002-249.538z',
    ],
  },
  {
    name: 'heart',
    paths: [
      'M755.188 64c-107.63 0-200.258 87.554-243.164 179-42.938-91.444-135.578-179-243.216-179-148.382 0-268.808 120.44-268.808 268.832 0 301.846 304.5 380.994 512.022 679.418 196.154-296.576 511.978-387.206 511.978-679.418 0-148.392-120.43-268.832-268.812-268.832z',
    ],
  },
  {
    name: 'plus',
    paths: [
      'M992 384h-352v-352c0-17.672-14.328-32-32-32h-192c-17.672 0-32 14.328-32 32v352h-352c-17.672 0-32 14.328-32 32v192c0 17.672 14.328 32 32 32h352v352c0 17.672 14.328 32 32 32h192c17.672 0 32-14.328 32-32v-352h352c17.672 0 32-14.328 32-32v-192c0-17.672-14.328-32-32-32z',
    ],
  },
  {
    name: 'minus',
    paths: [
      'M0 416v192c0 17.672 14.328 32 32 32h960c17.672 0 32-14.328 32-32v-192c0-17.672-14.328-32-32-32h-960c-17.672 0-32 14.328-32 32z',
    ],
  },
  {
    name: 'blocked',
    paths: [
      'M874.040 149.96c-96.706-96.702-225.28-149.96-362.040-149.96s-265.334 53.258-362.040 149.96c-96.702 96.706-149.96 225.28-149.96 362.040s53.258 265.334 149.96 362.040c96.706 96.702 225.28 149.96 362.040 149.96s265.334-53.258 362.040-149.96c96.702-96.706 149.96-225.28 149.96-362.040s-53.258-265.334-149.96-362.040zM896 512c0 82.814-26.354 159.588-71.112 222.38l-535.266-535.268c62.792-44.758 139.564-71.112 222.378-71.112 211.738 0 384 172.262 384 384zM128 512c0-82.814 26.354-159.586 71.112-222.378l535.27 535.268c-62.794 44.756-139.568 71.11-222.382 71.11-211.738 0-384-172.262-384-384z',
    ],
  },
  {
    name: 'cross',
    paths: [
      'M1014.662 822.66c-0.004-0.004-0.008-0.008-0.012-0.010l-310.644-310.65 310.644-310.65c0.004-0.004 0.008-0.006 0.012-0.010 3.344-3.346 5.762-7.254 7.312-11.416 4.246-11.376 1.824-24.682-7.324-33.83l-146.746-146.746c-9.148-9.146-22.45-11.566-33.828-7.32-4.16 1.55-8.070 3.968-11.418 7.31 0 0.004-0.004 0.006-0.008 0.010l-310.648 310.652-310.648-310.65c-0.004-0.004-0.006-0.006-0.010-0.010-3.346-3.342-7.254-5.76-11.414-7.31-11.38-4.248-24.682-1.826-33.83 7.32l-146.748 146.748c-9.148 9.148-11.568 22.452-7.322 33.828 1.552 4.16 3.97 8.072 7.312 11.416 0.004 0.002 0.006 0.006 0.010 0.010l310.65 310.648-310.65 310.652c-0.002 0.004-0.006 0.006-0.008 0.010-3.342 3.346-5.76 7.254-7.314 11.414-4.248 11.376-1.826 24.682 7.322 33.83l146.748 146.746c9.15 9.148 22.452 11.568 33.83 7.322 4.16-1.552 8.070-3.97 11.416-7.312 0.002-0.004 0.006-0.006 0.010-0.010l310.648-310.65 310.648 310.65c0.004 0.002 0.008 0.006 0.012 0.008 3.348 3.344 7.254 5.762 11.414 7.314 11.378 4.246 24.684 1.826 33.828-7.322l146.746-146.748c9.148-9.148 11.57-22.454 7.324-33.83-1.552-4.16-3.97-8.068-7.314-11.414z',
    ],
  },
  {
    name: 'checkmark',
    paths: ['M864 128l-480 480-224-224-160 160 384 384 640-640z'],
  },
  {
    name: 'play',
    paths: ['M192 128l640 384-640 384z'],
  },
  {
    name: 'pause',
    paths: ['M128 128h320v768h-320zM576 128h320v768h-320z'],
  },
  {
    name: 'stop',
    paths: ['M128 128h768v768h-768z'],
  },
  {
    name: 'loop',
    paths: [
      'M889.68 166.32c-93.608-102.216-228.154-166.32-377.68-166.32-282.77 0-512 229.23-512 512h96c0-229.75 186.25-416 416-416 123.020 0 233.542 53.418 309.696 138.306l-149.696 149.694h352v-352l-134.32 134.32z',
      'M928 512c0 229.75-186.25 416-416 416-123.020 0-233.542-53.418-309.694-138.306l149.694-149.694h-352v352l134.32-134.32c93.608 102.216 228.154 166.32 377.68 166.32 282.77 0 512-229.23 512-512h-96z',
    ],
  },
  {
    name: 'table1',
    paths: [
      'M0 192v704h1024v-704h-1024zM384 640v-128h256v128h-256zM640 704v128h-256v-128h256zM640 320v128h-256v-128h256zM320 320v128h-256v-128h256zM64 512h256v128h-256v-128zM704 512h256v128h-256v-128zM704 448v-128h256v128h-256zM64 704h256v128h-256v-128zM704 832v-128h256v128h-256z',
    ],
  },
  {
    name: 'table2',
    paths: [
      'M0 64v896h1024v-896h-1024zM384 640v-192h256v192h-256zM640 704v192h-256v-192h256zM640 192v192h-256v-192h256zM320 192v192h-256v-192h256zM64 448h256v192h-256v-192zM704 448h256v192h-256v-192zM704 384v-192h256v192h-256zM64 704h256v192h-256v-192zM704 896v-192h256v192h-256z',
    ],
  },
  {
    name: 'boat',
    paths: [
      'M256 256v170l256-84 256 84v-170h-512zM168 810l-80-284c-9.564-28.693 7.98-47.327 28-54l54-18v-198c0-46 40-86 86-86h128v-128h256v128h128c46 0 86 40 86 86v198l54 18c20.040 6.68 37.574 25.277 28 54l-80 284h-2c-68 0-130-36-172-84-42 48-102 84-170 84s-128-36-170-84c-42 48-104 84-172 84h-2zM854 896h84v86h-84c-58 0-118-14-172-42-108 56-232 56-340 0-54 28-114 42-172 42h-84v-86h84c60 0 120-20 172-56 104 72 236 72 340 0 52 36 112 56 172 56z',
    ],
  },
  {
    name: 'car',
    paths: [
      'M214 470h596l-64-192h-468zM746 682c36 0 64-28 64-64s-28-64-64-64-64 28-64 64 28 64 64 64zM278 682c36 0 64-28 64-64s-28-64-64-64-64 28-64 64 28 64 64 64zM808 256l88 256v342c0 24-18 42-42 42h-44c-24 0-42-18-42-42v-44h-512v44c0 24-18 42-42 42h-44c-24 0-42-18-42-42v-342l88-256c8-26 34-42 62-42h468c28 0 54 16 62 42z',
    ],
  },
  {
    name: 'sleep',
    paths: [
      'M810 298c94 0 172 78 172 172v384h-86v-128h-768v128h-86v-640h86v384h342v-300h340zM298 554c-70 0-128-58-128-128s58-128 128-128 128 58 128 128-58 128-128 128z',
    ],
  },
  {
    name: 'view-module',
    paths: [
      'M682 214h214v256h-214v-256zM426 470v-256h214v256h-214zM682 768v-256h214v256h-214zM426 768v-256h214v256h-214zM170 768v-256h214v256h-214zM170 470v-256h214v256h-214z',
    ],
  },
  {
    name: 'weekend',
    paths: [
      'M768 214c46 0 86 38 86 84v92c-50 18-86 64-86 120v88h-512v-88c0-56-36-102-86-120v-92c0-46 40-84 86-84h512zM896 426c46 0 86 40 86 86v214c0 46-40 84-86 84h-768c-46 0-86-38-86-84v-214c0-46 40-86 86-86s86 40 86 86v128h596v-128c0-46 40-86 86-86z',
    ],
  },
  {
    name: 'wifi',
    paths: [
      'M512 128c236 0 426 190 426 426 0 158-84 296-212 370l-44-74c102-60 172-170 172-296 0-188-154-340-342-340s-342 152-342 340c0 126 68 236 170 296l-42 74c-128-74-212-212-212-370 0-236 190-426 426-426zM768 554c0 94-52 178-128 222l-42-74c50-30 84-84 84-148 0-94-76-170-170-170s-170 76-170 170c0 64 34 118 84 148l-42 74c-76-44-128-128-128-222 0-142 114-256 256-256s256 114 256 256zM512 470c46 0 86 38 86 84s-40 86-86 86-86-40-86-86 40-84 86-84z',
    ],
  },
  {
    name: 'squares',
    paths: [
      'M810 470v-256h-256v256h256zM810 810v-256h-256v256h256zM470 470v-256h-256v256h256zM470 810v-256h-256v256h256zM128 128h768v768h-768v-768z',
    ],
  },
  {
    name: 'circle',
    paths: ['M86 512c0-236 190-426 426-426s426 190 426 426-190 426-426 426-426-190-426-426z'],
  },
  {
    name: 'upgrade',
    paths: [
      'M733.714 511.429c0-9.714-3.429-18.857-10.286-25.714l-258.857-258.857c-6.857-6.857-16-10.286-25.714-10.286s-18.857 3.429-25.714 10.286l-258.857 258.857c-6.857 6.857-10.286 16-10.286 25.714s3.429 18.857 10.286 25.714l52 52c6.857 6.857 16 10.286 25.714 10.286s18.857-3.429 25.714-10.286l108-108v286.857c0 20 16.571 36.571 36.571 36.571h73.143c20 0 36.571-16.571 36.571-36.571v-286.857l108 108c6.857 6.857 16 10.857 25.714 10.857s18.857-4 25.714-10.857l52-52c6.857-6.857 10.286-16 10.286-25.714zM877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z',
    ],
  },
  {
    name: 'info',
    paths: [
      'M448 304c0-26.4 21.6-48 48-48h32c26.4 0 48 21.6 48 48v32c0 26.4-21.6 48-48 48h-32c-26.4 0-48-21.6-48-48v-32z',
      'M640 768h-256v-64h64v-192h-64v-64h192v256h64z',
      'M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416z',
    ],
  },
  {
    name: 'brudd',
    // stroke="#EF4642" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
    paths: [
      'M20.8 21.4v-2.1l2.6-4c.9-1.4-.2-3.8-1-6.1m-2 6.8-1-3.5a1.2 1.2 0 1 0-2.3.6l1 3.8-.7 1.3c-.3 1-.5 2.1-.5 3.2m-12.6 0v-2.1l-2.7-4c-.9-1.4.2-3.8 1-6.1M4.7 16l.9-3.5A1.2 1.2 0 1 1 8 13l-1.1 4 .7 1.3c.3 1 .5 2.1.5 3.2m4.4-3.3h0l2.7 1.7',
      'M5.2 13.9 1.7 7.6a1 1 0 0 1 .4-1.3l5.1-3.5a.5.5 0 0 1 .8.4v3.3h1.8c.2 0 .4.2.4.5v3.7l3 4v-4.4l.1-.3 1.5-3.2c0-.2.3-.3.4-.3H17V3.2a.5.5 0 0 1 .8-.4l5.1 3.5c.5.3.6.8.4 1.3l-3.5 6.3m-7.3 4.3h0L9.8 20',
    ],
  },
  {
    name: 'alert',
    paths: [
      'm32.3 25.8-13-22.4a3.2 3.2 0 0 0-5.5 0L.8 25.8c-.5 1-.5 2.2 0 3.2.6 1 1.7 1.6 2.8 1.6h26a3.2 3.2 0 0 0 2.7-4.8Zm-15.7.3a1.7 1.7 0 1 1 0-3.5 1.7 1.7 0 0 1 0 3.5Zm1.7-6.8a1.8 1.8 0 0 1-3.5 0v-6.6a1.8 1.8 0 0 1 3.5 0v6.6Z',
    ],
  },
  {
    name: 'fotball',
    paths: [
      'M11.5333 4.90035C12.9415 4.32008 14.4844 4 16.1021 4C17.6663 4 19.199 4.30541 20.6206 4.88321C20.6677 4.89747 20.7136 4.91638 20.7574 4.9398C22.1751 5.53654 23.4785 6.40593 24.5873 7.51472C26.8378 9.76516 28.1021 12.8174 28.1021 16C28.1021 16.3207 28.0895 16.6384 28.0648 16.9527C28.0642 16.9636 28.0633 16.9746 28.0622 16.9855C27.5609 23.1519 22.3977 28 16.1021 28C9.80644 28 4.64316 23.1519 4.14193 16.9855C4.14082 16.9746 4.13995 16.9637 4.13932 16.9527C4.11463 16.6384 4.10205 16.3207 4.10205 16C4.10205 11.0054 7.15345 6.72345 11.4937 4.91674C11.5068 4.9109 11.52 4.90543 11.5333 4.90035ZM11.724 6.4535C10.4494 7.03896 9.31232 7.87214 8.37425 8.89139L8.99759 12.9952L11.0114 13.9818L15.3521 10.826V8.89894L11.724 6.4535ZM16.8521 8.89894V10.826L21.1927 13.9818L23.2065 12.9952L23.8298 8.89145C23.7312 8.78421 23.6301 8.67883 23.5267 8.57538C22.6358 7.68451 21.6013 6.97026 20.4777 6.45516L16.8521 8.89894ZM18.7193 5.8314C17.8714 5.61312 16.9925 5.5 16.1021 5.5C15.1974 5.5 14.3195 5.6144 13.482 5.82953L16.1021 7.59554L18.7193 5.8314ZM25.0915 10.574L24.6876 13.2328L26.5635 15.1011C26.4254 13.4923 25.9185 11.9443 25.0915 10.574ZM26.5354 17.19L23.7387 14.4048L21.7326 15.3876L20.0532 20.5754L21.1283 21.7789L25.2573 21.1449C25.9293 19.9517 26.3747 18.614 26.5354 17.19ZM24.0638 22.8457L21.3412 23.2638L20.1524 25.6903C21.6699 25.0553 23.0066 24.0742 24.0638 22.8457ZM18.1868 26.2931L19.9445 22.7053L18.8714 21.504H13.3327L12.2596 22.7053L14.0174 26.2931C14.6911 26.4288 15.3883 26.5 16.1021 26.5C16.8158 26.5 17.513 26.4288 18.1868 26.2931ZM12.0517 25.6903L10.8629 23.2638L8.14029 22.8457C9.19753 24.0742 10.5342 25.0553 12.0517 25.6903ZM6.94676 21.1449L11.0758 21.7789L12.1509 20.5754L10.4715 15.3876L8.46536 14.4048L5.66874 17.19C5.82937 18.614 6.27482 19.9517 6.94676 21.1449ZM5.63994 15.1017L7.51647 13.2328L7.11227 10.5717C6.29975 11.9144 5.77956 13.4538 5.63994 15.1017ZM11.9682 15.1407L13.5426 20.004H18.6615L20.2359 15.1407L16.1021 12.1353L11.9682 15.1407Z',
    ],
  },
] as const;

/** For icons that need special viewbox or display style, place them here */
const optionalAttributes = new Map<
  AllIconNames,
  { viewBox?: string; style?: SVGProps<SVGElement>; size?: CSSProperties['width'] }
>([
  [
    'brudd',
    {
      viewBox: '0 0 25 24',
      style: {
        strokeWidth: '1.5',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      },
    },
  ],
  [
    'alert',
    {
      viewBox: '0 0 33 32',
      size: '32px',
      style: {
        fill: '#E01C17',
      },
    },
  ],
  [
    'fotball',
    {
      viewBox: '4 4 24 24',
      size: '32px',
      style: {
        fill: 'black',
      },
    },
  ],
]);

type IconNames = (typeof data)[number]['name'];
export type AllIconNames = IconNames | FileIcons;
type LooseIconName = LooseStringUnion<IconNames>;

const getIconData = (name: LooseIconName) => data.find((x) => x.name === name);
export const iconExists = (name: LooseIconName): name is IconNames => getIconData(name)?.paths != null;
export const getPath = (name: IconNames) => getIconData(name)?.paths.join(' ') ?? '';
export const getIconAttributes = (name: IconNames) => optionalAttributes.get(name);

/* Generator
export const generateIcons = () =>
    selection.map(x => ({
        name: x.tags[0],
        paths: x.paths
    }));
console.log(JSON.stringify(generateIcons()));*/
